module.exports = __webpack_public_path__ + "static/media/siddharth-guntur-trip-01.6e0fbd48.png";